export const email: string = "hello@outa.app"
